import 'jquery-ui/ui/widgets/datepicker';

const dayjs = require('dayjs');

(function ($) {
  const datepickerClass = 'form__input--date';
  const $groups = $('.wpcf7-field-groups');

  // eslint-disable-next-line  no-unused-vars
  let focusedTriggerId = null;

  $('body').on('wpcf7-field-groups/change', '.wpcf7-field-groups', function () {
    // For each group inside this we have to adjust name parameter.
    const $groupsInside = $(this).find('.wpcf7-field-group');
    $groupsInside.each(function (index) {
      $(this).find('.wpcf7-field-group-remove').toggle(index > 0);
      const i = index + 1;
      $(this).find('[name]').each(function () {
        const $$ = $(this);
        const labelElement = $$.parent().prev();
        const $formControlWrap = $$.closest('.wpcf7-form-control-wrap');
        const name = $$.attr('name');
        const isArray = (name.indexOf('[]') > -1);
        const rawName = name.replace('[]', '');
        let newName = `${rawName.replace(/__[0-9]*/, '')}__${i}`;
        const newId = newName;

        // The form control wrap class doesn't have `[]` chars...
        if ($formControlWrap.length && !$formControlWrap.hasClass(newName)) {
          $formControlWrap.removeClass(rawName).addClass(newName);
        }
        // but the field can have.
        newName += (isArray) ? '[]' : '';
        $$.attr('name', newName);
        $$.attr('id', newId);
        // label connect
        if (labelElement[0].tagName.toLowerCase() === 'label') {
          labelElement.attr('for', newId);
        }
      });
    });
    $(this).find('.wpcf7-field-group-count').val($groupsInside.length);
  });

  function toggleTotalInfoRow() {
    const availableFields = $groups.find('.wpcf7-field-group').length;
    const totalBlock = $('.form__row--totals');
    const totalEls = totalBlock.find('.form__col').not(':first-of-type');

    if (availableFields < 1) {
      totalEls.addClass('d-none');
    } else {
      totalEls.removeClass('d-none');
    }
  }

  $(document).on('click', '#add-day', () => {
    const $newGroup = $groups.data('group-model').clone(true);
    $groups.append($newGroup);
    $groups.trigger('wpcf7-field-groups/change');
    toggleTotalInfoRow();
    return false;
  });

  $groups.on('click', '#remove-day', function () {
    $(this).closest('.wpcf7-field-group').remove();
    $('.form__row--repeater .form__input--text').trigger('change');
    toggleTotalInfoRow();
  });

  document.querySelectorAll('.wpcf7-validates-as-required').forEach((item) => {
    if (!item.classList.contains('empty-placeholder')) {
      // eslint-disable-next-line no-param-reassign
      item.placeholder = `${item.placeholder}*`;
    }
  });

  $(document).on('mouseleave', '#add-day', (event) => {
    $(event.target).blur().off('mouseleave');
  });

  /**
   * Rooms regex input
   * @param str
   * @returns {boolean}
   */
  function roomsRegexInput(str) {
    const regex = /[0-9]|\./;
    if (!regex.test(str)) {
      return false;
    }
    return true;
  }

  /**
   * todo: should be refactored to be universal function
   * @param datepicker
   */
  function moveTabIndexToDatepickerCells() {
    setTimeout(() => {
      const $prevMonth = $('.ui-datepicker-prev:not(".ui-state-disabled")');
      const $nextMonth = $('.ui-datepicker-next:not(".ui-state-disabled")');
      const $activeCells = $('.ui-datepicker td:not(".ui-state-disabled")');

      $prevMonth.attr('tabindex', 1);
      $activeCells.each(function (idx) {
        $(this).attr('tabindex', idx + 2);
      });
      $nextMonth.attr('tabindex', $activeCells.length + 3);
      $activeCells.keypress(function (event) {
        const code = (event.keyCode ? event.keyCode : event.which);
        if (code === 13) {
          $(this).find('a').click();
        }
      });
      $prevMonth.add($nextMonth).keypress(function (event) {
        const code = (event.keyCode ? event.keyCode : event.which);
        if (code === 13) {
          $(this).click();
        }
      });
      $activeCells.first().focus();
    }, 0);
  }

  /**
   * todo: should be refactored to be universal function
   *
   * @returns {
   *  {
   *    dateFormat: string,
   *    onSelect: onSelect,
   *    onChangeMonthYear:
   *    onChangeMonthYear,
   *    beforeShow: beforeShow
   *    }
   * }
   */
  function datepickerDefaultSettings() {
    return {
      dateFormat: 'mm/dd/yy',
      onSelect(date, datepicker) {
        const datepickerValue = `${datepicker.currentMonth}/${datepicker.currentDay}/${datepicker.currentYear}`;
        // eslint-disable-next-line no-undef
        pendryFormAutoLabel(datepicker.id, datepickerValue);
        // $(`#${datepicker.id}`).datepicker('destroy').focus();
      },
      onChangeMonthYear(month, year, datepicker) {
        moveTabIndexToDatepickerCells(datepicker);
      },
      beforeShow(elem, datepicker) {
        moveTabIndexToDatepickerCells(datepicker);
      },
      onClose() {
        const currentField = this.closest('.form__col');
        const nextFocusableElement = currentField?.nextElementSibling.querySelector('input');
        $(nextFocusableElement).focus();
      },
    };
  }

  /**
   * todo: should be refactored to be universal function
   *
   * @returns {*}
   */
  function datepickerSettings() {
    const defaultSettings = datepickerDefaultSettings();
    return $.extend(defaultSettings, {
      minDate: 0,
    });
  }

  function removeAjaxLoaderDuplicates() {
    if ($('.wpcf7 .wpcf7-submit').length === 0) {
      return;
    }

    $('.wpcf7').each((idx, el) => {
      const $submitBtns = $(el).find('.wpcf7-submit');

      // here check, that all submit under one parent
      $submitBtns.each((i, item) => {
        $(item).parent().find('.ajax-loader:not(:last)').remove();
      });
    });
  }

  function scrollToFirstErrorTip(event) {
    setTimeout(() => {
      const $currentForm = $(event.target).closest('form');
      const tipElement = '.wpcf7-not-valid-tip';

      if ($currentForm.find(tipElement).length !== -1) {
        $('body,html').animate({ scrollTop: $(tipElement).offset().top - 200 }, 800);
        $(tipElement).first().prev('.form__input').focus()
          .click();
      }
    }, 250);
  }

  function addPreferredDatesStyles(event) {
    setTimeout(() => {
      const $currentForm = $(event.target).closest('form');
      const tipElement = '.wpcf7-not-valid-tip';
      const preferredDates = '.wpcf7-form-control-wrap.preferred_dates';

      if ($currentForm.find(preferredDates).length > 0) {
        if ($currentForm.find(`${preferredDates} ${tipElement}`).length > 0) {
          $(preferredDates).closest('.form__row').find('.form__col').addClass('wpcf7-pendry-invalid');
        } else {
          // in case of re-validation and getting errors.
          $(preferredDates).closest('.form__row').find('.form__col').removeClass('wpcf7-pendry-invalid');
        }
      }
    }, 250);
  }

  /**
     * Count types of room.
     * Example: Single, Double, Suite
     */
  const roomTypesCount = 3;

  /**
     * Row totals
     * @type {*|HTMLElement}
     */
  const $rowTotals = $('.form__row--totals');

  /**
     * Initial room row
     * @type {*|HTMLElement}
     */
  const $initialRoomRow = $('.form__row--repeater');

  /**
     * Available key codes
     * @type {number[]}
     */
  const availableKeyCodes = [8, 9, 37, 38, 39, 40, 46];

  /**
     * Daily total calculation
     * Sum values rooms by type in he row
     */
  $(document).on('change', '.form__row--repeater .form__input--text', function () {
    /**
         * Rooms in day
         * @type {Array}
         */
    const roomsInDay = [];

    /**
         * Rooms in type
         * @type {Array}
         */
    const roomsInType = [];

    /**
         * Total daily
         */
    let totalDaily = 0;

    /**
         * Room row object
         * @type {Element}
         */
    const $roomRow = $(this).closest('.form__row--repeater');

    /**
         * All rooms objects
         * @type {*|HTMLElement}
         */
    const $allRoomsRows = $('.form__row--repeater');

    $roomRow.find('.form__input--text').each(function (i) {
      if (i === roomTypesCount) {
        return;
      }
      roomsInDay.push(parseInt($(this).val(), 10) || 0);
    });

    totalDaily = roomsInDay.reduce((sum, current) => sum + current, 0);

    $roomRow.find('.form__input--text').each(function (i) {
      if (i === roomTypesCount) {
        $(this).val(totalDaily);
      }
    });

    $allRoomsRows.each(function () {
      const $row = $(this);
      $row.find('.form__input--text').each(function (j) {
        roomsInType[j] = (roomsInType[j] || 0) + (parseInt($(this).val(), 10) || 0);
      });
    });

    $rowTotals.find('.form__input--text').each(function (i) {
      $(this).val(roomsInType[i]);
    });
    $rowTotals.find('.form__input--hidden').each(function (i) {
      $(this).val(roomsInType[i]);
    });
  });

  // eslint-disable-next-line  consistent-return
  $(document).on('keydown', '.form__row--repeater .form__input--text', (event) => {
    if (roomsRegexInput(event.key) === false && availableKeyCodes.indexOf(event.keyCode) === -1) {
      return false;
    }
  });

  $initialRoomRow.find('.form__input--text').each(function (i) {
    if (i === roomTypesCount) {
      $(this).attr('readonly', 'readonly');
    }
  });

  $rowTotals.find('.form__input--text').each(function () {
    $(this).attr('disabled', 'disabled');
  });

  // File upload button
  $('.rfp_file')
    .addClass('form__attachment-button c-button c-button--primary c-button--animated')
    .attr('tabindex', '0')
    .append('Upload file')
    .on('click', () => {
      document.getElementById('rfp_file').click();
    })
    .bind('change', () => {
      const rfpFileName = $('#rfp_file')[0].files[0].name;
      $('.form__attachment-info').html(`<span class="form__attachment-file">${rfpFileName}</span><span class="form__attachment-remove" tabindex="0">Remove</span>`);
      // File remove
      $('.form__attachment-remove').on('click', (event) => {
        event.preventDefault();
        $('.rfp_file input').val('');
        $('.form__attachment-info').html('');
      });
    });

  $('.dates_flexible, .room_patterns_flexible').attr('tabindex', '0');

  $(document).ready(() => {
    // Datepicker by mouse
    $(document).on('click', '.form__input--date', (event) => {
      focusedTriggerId = $(event.target).attr('id');
      $(event.target).datepicker(datepickerSettings());
      $(event.target).datepicker('show');
      return false;
    });
    // eslint-disable-next-line  consistent-return
    $(window).on('keydown', (event) => {
      // Datepicker by keyboard
      if (event.keyCode === 13 && $(event.target).hasClass(datepickerClass)) {
        focusedTriggerId = $(event.target).attr('id');
        $(event.target).datepicker(datepickerSettings());
        $(event.target).datepicker('show');
        return false;
      }
      // Are Dates Flexible? by keyboard
      if (event.keyCode === 13 && $(event.target).hasClass('dates_flexible')) {
        $(event.target).find('input[type="checkbox"]').click();
      }
      // Is Rooms Pattern Flexible? by keyboard
      if (event.keyCode === 13 && $(event.target).hasClass('room_patterns_flexible')) {
        $(event.target).find('input[type="checkbox"]').click();
      }
      // Attachment button
      if (event.keyCode === 13 && $(event.target).hasClass('form__attachment-button')) {
        $(event.target).click();
      }
      // Remove attachment icon
      if (event.keyCode === 13 && $(event.target).hasClass('form__attachment-remove')) {
        $('.form__attachment-button').focus();
        $(event.target).click();
      }
    });
    removeAjaxLoaderDuplicates();
  });

  $(window).on('load', () => {
    setTimeout(() => {
      $('.wpcf7-submit.form__button').on('click', (event) => {
        addPreferredDatesStyles(event);
        scrollToFirstErrorTip(event);
      });
    }, 250);
  });

  function removeTabIndexFromDisabledInputs() {
    const disabledEls = document?.querySelectorAll('.form__input--disabled');

    disabledEls.forEach((el) => el.setAttribute('tabindex', '-1'));
  }

  removeTabIndexFromDisabledInputs();

  // eslint-disable-next-line  no-unused-vars
  function getDateByFormat(dateRaw, dateFormat) {
    return dayjs(dateRaw, dateFormat).toDate();
  }

  toggleTotalInfoRow();
  // eslint-disable-next-line  no-undef
}(jQuery));
